import React from 'react'
import {injectIntl} from 'react-intl';

@injectIntl
export default class TableHeaderControl extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            reverse: false
        }
    }

    render() {

        const {growStore} = this.props;
        const {cmp} = this.props;
        const {query} = this.props;

        var icon = this.state.reverse ? 'fa fa-caret-down' : 'fa fa-caret-up';

        return (
            <th>
                <span>{this.props.title[query]}</span>
                <span> <div>
                            <i className={icon} onClick={() => {
                                this.setState({reverse: !this.state.reverse}, () => {
                                    growStore.cmp = cmp[query];
                                    growStore.reverse = this.state.reverse;
                                    growStore.page = 1;
                                })
                            }
                            }/>
                        </div>
                </span>
            </th>
        );

    }
}